import { defaultTo } from "lodash";
import { DateTime } from "luxon";
import { IModel, Model, ModelRecord } from "./Model";

export interface IHospitalPrescriptionRefillListingModel extends IModel {
    hospitalPrescriptionRefillId: number;
    hospitalPrescriptionRefillStatusId: number;
    dateFilled: string | undefined;
    hospitalPrescriptionId: number;
    visitSalesItemId: number | undefined;
    hospitalId: number;
    dateCreated: string;
    dateUpdated: string;
    invoiceId: number;
}

export class HospitalPrescriptionRefillListingModel extends Model implements ModelRecord<IHospitalPrescriptionRefillListingModel> {
    hospitalPrescriptionRefillId: number;
    hospitalPrescriptionRefillStatusId: number;
    dateFilled: DateTime | undefined;
    hospitalPrescriptionId: number;
    visitSalesItemId: number | undefined;
    hospitalId: number;
    dateCreated: DateTime | undefined;
    dateUpdated: DateTime | undefined;
    invoiceId: number;

    constructor(params?: Partial<IHospitalPrescriptionRefillListingModel>) {
        super(params);
        this.hospitalPrescriptionRefillId = defaultTo(params?.hospitalPrescriptionRefillId, 0);
        this.hospitalPrescriptionId = defaultTo(params?.hospitalPrescriptionId, 0);
        this.hospitalPrescriptionRefillStatusId = defaultTo(params?.hospitalPrescriptionRefillStatusId, 0);
        this.dateFilled = params?.dateFilled ? DateTime.fromISO(params?.dateFilled) : undefined;
        this.visitSalesItemId = params?.visitSalesItemId;
        this.hospitalId = defaultTo(params?.hospitalId, 0);
        this.dateCreated = params?.dateCreated ? DateTime.fromISO(params?.dateCreated, { zone: "utc" }) : undefined;
        this.dateUpdated = params?.dateUpdated ? DateTime.fromISO(params?.dateUpdated, { zone: "utc" }) : undefined;
        this.rowVersion = defaultTo(params?.rowVersion, "");
        this.invoiceId = defaultTo(params?.invoiceId, 0)
    }
}
